import React from 'react';
import { motion } from 'framer-motion';
import './Overlays.css'
import Celebration from './Celebration';

// Dynamic team name generator
function getTeamNames(mode, players) {
  // Helper to safely grab names or fallback to 'Seat X' if a player disconnected
  const getNames = (indices) => {
    return indices
      .map(i => (players && players[i] && players[i].name) ? players[i].name : `P${i+1}`)
      .join(' & ');
  };

  if (mode === '56') {
    return [
      `Team ♦ (${getNames([0, 2, 4])})`,
      `Team ♠ (${getNames([1, 3, 5])})`
    ];
  }
  return [
    `Team ♦ (${getNames([0, 2])})`,
    `Team ♠ (${getNames([1, 3])})`
  ];
}

export default function MatchOverPanel({ gs, myId, send }) {
  // Explicitly convert to number to prevent 'undefined' array lookups
  const mw = Number(gs.match_winner); 
  const myTeam = myId % 2;
  const iWon = myTeam === mw;
  
  // Pass the players array into our helper
  const teams = getTeamNames(gs.mode, gs.players);

  // Host check
  const myPlayerObj = gs.players && gs.players[myId];
  const isHost = myPlayerObj && myPlayerObj.id === gs.host_id;

  return (
    <>
      {iWon && <Celebration />}
      <motion.div 
        initial={{ opacity: 0, scale: 0.8, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ type: "spring", bounce: 0.4, duration: 0.8 }}
        className={`match-over-panel ${iWon ? 'match-over-winner' : 'match-over-loser'}`}
        style={{ filter: iWon ? 'none' : 'grayscale(0.2)' }}
      >
        <motion.div 
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: "spring", bounce: 0.6 }}
          style={{ fontSize: 64, marginBottom: 8 }}
        >
          {iWon ? '🏆' : '😔'}
        </motion.div>
        
        <h3 className={`match-over-title ${iWon ? 'title-winner' : 'title-loser'}`}>
          {iWon ? 'Victory!' : 'Defeat'}
        </h3>
        
        <p className="match-over-subtitle">
          <strong>{teams[mw]}</strong> claims the match.
        </p>

        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.4 }}
          style={{ marginTop: 24 }}
        >
          {isHost ? (
            <button className="glow-btn" onClick={() => send('new_match', {})}>
              Play Again
            </button>
          ) : (
            <p style={{ color: '#94a3b8', fontStyle: 'italic', margin: 0, padding: '10px' }}>
              Waiting for host to start a new match...
            </p>
          )}
        </motion.div>
      </motion.div>
    </>
  );
}